<template>
  <div>
    <div>
      <p style="font-size: 16px;line-height: 28px;">郑莹莹 电话：010-84255960 邮箱：<a href="mailto:zhengyingying@ccpitchem.org.cn">zhengyingying@ccpitchem.org.cn</a></p>      
      <el-button type="primary"><a :href="file2" style="font-size:14px;color:#fff;text-decoration:none;" target="_blank">FSHOW宣传方案</a></el-button>
    </div>
  </div>
</template>
<script>
import api from '@/api'
import tools from '../../utils/tools.js';
export default {
  data: () => ({
     saveBtnStatue:false,  //保存铵钮状态
      tableData: [],
      getDataString:"广告申请", //获取数据，提交数据 使用
      allData:[{
        text:"费用合计：",
        price:0
      }],
      totalPrice: 0,
      buttonStyle: sessionStorage.getItem('buttonStyle') ? JSON.parse(sessionStorage.getItem('buttonStyle')) : {},
      file2:'./FSHOW2025宣传方案.pdf',
  }),

  components: {},
  mounted() {

  },
  methods: {
    downfile(){

    },


  }
}
</script>
<style lang="less">


</style>

